import React from "react";

const About = () => {
  return (
    <div className="font-sans text-gray-900 bg-white">
      {/* Founder Section */}
      <section className="px-6 py-5 bg-white">
        <h2 className="text-4xl font-bold text-center mb-12">The Mind Behind the Masterpieces</h2>
        <div className="grid md:grid-cols-12 gap-8 max-w-6xl mx-auto w-full md:w-10/12 items-center justify-center ">
          <div className="col-span-6">
            <div className="mb-4 flex justify-center items-center flex-col">
              <h3 className="text-lg font-bold">Mayur Datta Borker</h3>
              <p>Founder</p>
            </div>
            <div className="flex justify-center items-center">
              <img
                src="/images/founder.png"
                alt="Founder"
                className="object-cover shadow-lg"
              />
            </div>
          </div>

          <div className="col-span-6 text-center md:text-left">
            <p className="text-gray-700 text-base mb-6">
              A qualified Bachelor of Architecture, honored with the globally recognized{" "}
              <span className="text-red-600">"Charles Correa Award"</span>, and with{" "}
              <span className="text-red-600">26 years of experience</span> in Architecture and Interiors. With{" "}
              <span className="text-red-600">18 years</span> of running our own firm{" "}
              <span className="text-red-600">SM6</span>, we have also achieved the{" "}
              <span className="text-red-600">IIID Award</span> for Creative Office Design.
            </p>

            <p>
              We place <span className="text-red-600">human experience</span> at the center of our design process to deliver{" "}
              <span className="text-red-600">engaging, future-oriented projects</span> that respond to how people actually use space.{" "}
              SM6 Corp approaches each development as a <span className="text-red-600">boutique project, customized to a high degree</span>.{" "}
              Every site we design has its own inherent qualities.
            </p>
          </div>
        </div>
      </section>

      {/* Stats & Awards Section */}
      <section className="px-6 py-5 bg-gray-50">
        <h2 className="text-4xl font-bold text-center mb-5">Our Achievements</h2>
        <div className="mt-5 grid md:grid-cols-3 gap-8 text-center">
          <div className="bg-white p-8 rounded-xl shadow hover:shadow-lg transition transform hover:scale-105">
            <h3 className="text-3xl font-bold text-red-600">17</h3>
            <p className="mt-2 text-gray-700">Years of Market Presence</p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow hover:shadow-lg transition transform hover:scale-105">
            <h3 className="text-3xl font-bold text-red-600">60+</h3>
            <p className="mt-2 text-gray-700">Projects Delivered</p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow hover:shadow-lg transition transform hover:scale-105">
            <h3 className="text-3xl font-bold text-red-600">45+</h3>
            <p className="mt-2 text-gray-700">Turnkey Projects</p>
          </div>
        </div>

        <div className="mt-5 text-center mx-auto">
          <h3 className="text-3xl font-bold mb-4">Awards</h3>
          <p className="text-gray-700">
            Incepted in 2007, we are a proud recipient of the Charles Correa Award & IIID Award for
            “Best office space design in South India”.
          </p>
          <div className="flex mt-4 justify-around items-center">
            <img src="/images/award.png" className="awardImg mt-2" />
            <img src="/images/award2.jpg" className="awardImg mt-2" />
          </div>

        </div>

        <div className="mt-16 text-center max-w-3xl mx-auto hidden">
          <h3 className="text-3xl font-bold mb-4">Portfolios</h3>

          <div className="pdfBox mt-2">
            <object
              data="/images/sm6_corp.pdf"
              type="application/pdf"
              className="pdfViewer"
            >
              <p>Your browser doesn't support PDF preview.
                <a href="/images/sm6_corp.pdf" target="_blank">Download PDF</a>
              </p>
            </object>
          </div>
        </div>


      </section>
    </div>
  );
};

export default About;
